import React from 'react';
import PropTypes from 'prop-types';
import MessageNote from './MessageNote';
import RegularNote from './RegularNote';
import { INTERACTION_TYPES } from './constants';
import './Note.scss';

const Note = (props) => (
  props.noteType === INTERACTION_TYPES.MESSAGE ? (
    <MessageNote {...props} />
  ) : (
    <RegularNote {...props} />
  )
);

Note.defaultProps = {
  currentEmployeeId: '',
  duration: null,
  noteType: 'Note',
  note: {},
  details: {},
  reason: '',
  showDeleteNoteIcon: false,
  visibility: '',
  renderTextAsHtml: false,
};

Note.propTypes = {
  currentEmployeeId: PropTypes.string,
  interactionDate: PropTypes.object.isRequired,
  interactionType: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  duration: PropTypes.string,
  category: PropTypes.string.isRequired,
  details: PropTypes.object,
  reason: PropTypes.string,
  note: PropTypes.object,
  noteType: PropTypes.string,
  visibility: PropTypes.string,
  showDeleteNoteIcon: PropTypes.bool,
  renderTextAsHtml: PropTypes.bool,
};

export default Note;
